/** Public, versioned text. A changed native form requires a matching UI review. */
export const WEEKLY_CONSENT =
  "Quiero recibir el resumen semanal de cambios de Codifly. Puedo darme de baja en cualquier momento.";
export const LEAD_SOURCES = {
  "codifly-overview": "subscription",
  newsletter: "subscription",
  aws_savings_calculator: "contact",
  "codifly-contact": "contact",
  "codifly-advisory": "commercial",
} as const;
export type LeadSource = keyof typeof LEAD_SOURCES;
export type FormIntent = (typeof LEAD_SOURCES)[LeadSource];
export type LeadInput = {
  source: LeadSource;
  email: string;
  consent: true;
  name?: string;
  message?: string;
  company?: string;
  website?: string;
  category?: string;
  products?: string[];
  campaign?: string;
  metadata?: {
    spend: number;
    idle: number;
    commitment: number;
    low: number;
    high: number;
  };
};
export type LeadDescriptor = {
  mode: "legacy" | "published";
  versionId: string | null;
  consentText: string | null;
};
export function nativeFormFields(intent: FormIntent) {
  const field = (
    id: string,
    type: string,
    title: string,
    required = false,
  ) => ({ id, key: id, type, title, validation: { required } });
  return [
    field("email", "email", "Correo electrónico", true),
    field("name", "short_text", "Nombre"),
    field("category", "hidden", "Categoría de origen"),
    field("products", "hidden", "Productos comparados"),
    field("campaign", "hidden", "Campaña de origen"),
    ...(intent === "subscription"
      ? [field("weekly_optin", "consent", WEEKLY_CONSENT, true)]
      : [
          ...(intent === "commercial"
            ? [field("company", "short_text", "Empresa")]
            : []),
          field(
            "message",
            "long_text",
            intent === "commercial" ? "¿En qué podemos ayudarte?" : "Mensaje",
            true,
          ),
        ]),
  ];
}
